module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAAAAADEa8dEAAABMklEQVQ4y7XUMUvDQBgG4P6O965BKhXFqygaCiIIjm7+AMFZKJ2cdLgf4GJAl3bxF4SAi0txKZ3dOoQiiFMpRcShHFLvEqq5+l1aLb7j8UC+e8N3hfEcKfwNhc05EMdgNgLiBVAcSBmMplBDysvHL9RehUndRlfJ4XKUohbAykLsdGzUqwqxotltgspY77lm6lfhvWrUBntyD/7moamRhMi73R5ONKrBz0OHOPofpGykKBTzyvAbqV3cE+iFY204QcoH61CfC1NlkDHX9OCp0ihjft4uUUA3Y4gKjAK2MobqSSvGsoYsUyvL0I2H3DKO3/LcHc9GU/kFukAlD+3jWKMH8L7bjJZwYxahhG2nej9AcWBQpJvZ8MlsFoEgXc6oBGe8xmTNP1rnp2TO7tQCjxiRT0ap9GABfVDdAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/new/index/down_load_icon.png
// module id = Ymsp
// module chunks = 24